import forgotPasswordModel from '../../models/forgot-password.model';
import samsungLogoBlack from "../../../images/samsung-logo-black.svg";
import ssklogo from "../../../images/mcs-logo-v2-v2.svg";
import ViewBase from '../view-base.view';


export default function ForgotView() {
  ViewBase.call(this);

  let forgotCredentials = { email: '' }

  const forgot = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    // Validation passed
    submitForgotPassword();

    return false;
  }

  const submitForgotPassword = () => {
    this.showLoading();
    forgotPasswordModel.forgot(
      forgotSuccessCallBack,
      forgotFailureCallBack,
      forgotCredentials.email
    )
  }

  const forgotSuccessCallBack = () => {
    this.hideLoading();
    this.showMessage("Please check your email to reset password.", null, dialogClosed);
  }

  const forgotFailureCallBack = (error) => {
    this.hideLoading();
    this.handleError(error)
  }

  function setEmail(e) {
    forgotCredentials.email = e.target.value
  }

  function dialogClosed() {
    m.route.set("/login");
  }

  return {
    view: () => {
      return [
        m('.container-login-form',
          m('.form-signin.m-3',
            m('.d-flex.justify-content-start.mb-2',
              m('img.img-responsive.samsung-logo-v2', { "src": samsungLogoBlack })
            ),
            m('.d-flex.justify-content-center.p-4.mb-5',
              m('img.img-responsive.login-logo-size', { "src": ssklogo })
            ),
            m('h3.sign-in-style.mb-4', 'Reset your password'),
            m('form.needs-validation[novalidate]', { onsubmit: forgot },
              m('.row.mb-4',
                m('.col-12.position-relative',
                  m('label.form-label[for=userIdOrEmailInput]', 'User ID / Email Address:'),
                  m('input#userIdOrEmailInput.form-control.form-control-bg[type="text"][placeholder="User ID / Email Address"][required]', {
                    onchange: setEmail
                  }),
                  m('.invalid-tooltip', 'User ID / Email is required'),
                ),
                m('.col-12.form-text.text-danger', 'For Samsung employee, please use your User ID.'),
              ),
              m('.d-flex.flex-column.gap-2',
                m('button.btn.btn-primary.submit[type="submit"]', 'Submit'),
                m(m.route.Link, {
                  class: 'btn btn-secondary',
                  href: '/login'
                },
                  'Back to Login'
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}
